import { useEffect, useRef } from 'react'
import SvgIcon from '../svg/SvgIcon'
import { spinRing } from '../svg/spinRing'
import { connect } from 'react-redux'

const SpinButton = props => {
  const spinButton = useRef(null)

  const {
    enabled = false,
    onClick,
    scale = 1,
    width,
    height,
    available,
    type,
    svgIcons,
    delayingSpin,
    paused,
    enableSpinRingAnimation,
  } = props
  const availableClass = available ? '' : 'hidden'

  const buttonProps = {
    className: `${type}-button ${availableClass}`
  }

  const mobileLandscape = width <= 900 && width > height
  let transform = {}
  if (mobileLandscape) {
    const translateY = width > height ? 'translateY(-50%)' : ''
    transform = { transform: `scale(${scale}) ${translateY}` }
  }

  const style = transform

  const { spinDelay } = window.config.JURISDICTION_CONFIG
  const enableSpinRing = enableSpinRingAnimation && delayingSpin && !!spinDelay

  useEffect(() => {
    if (spinDelay) {
      const circle = spinButton.current.querySelector('#spin-ring-jurisdiction')
      if (circle) {
        circle.style.strokeDashoffset = enableSpinRing ? Math.PI * 2 * circle.r.baseVal.value : 0
        circle.style.transition = enableSpinRing ? `stroke-dashoffset ${spinDelay / 1000}s linear` : 'none'
      }
    }
  }, [delayingSpin])

  useEffect(() => {
    const circle = spinButton.current.querySelector('#spin-ring-jurisdiction')
    if (circle) {
      circle.style.visibility = paused ? 'hidden' : 'visible'
    }
  }, [paused])

  const iconProps = {
    disabled: !enabled,
    onClick,
    iconName: enabled ? type : 'skip-disabled',
    hasClickIcon: true,
    injectedElement: enableSpinRing ? spinRing : undefined,
    reference: spinButton,
  }

  return (
    <div {...buttonProps} style={{ ...style }}>
      <SvgIcon
        svgIcons={svgIcons}
        {...iconProps}
      />
    </div>
  )
}

export default connect(state => ({
  enableSpinRingAnimation: state.UI.enableSpinRingAnimation,
}))(SpinButton)